import { useEffect, useState } from "react"
import { Alert } from "react-bootstrap"
import { Redirect } from "react-router-dom/cjs/react-router-dom.min"
import { APP_DIRECTORY } from "../SystemVariables"
import "./RedirectCountdown.css"

const RedirectCountdownToLogin = () => {
    const [remainingSeconds, setRemainingSeconds] = useState(5)
    const [redirect, setRedirect] = useState(false)
    const [countdownComplete, setCountdownComplete] = useState(false)

    useEffect(()=>{
        if(remainingSeconds > 0) {
            const timeout = setTimeout(()=>{
                setRemainingSeconds(remainingSeconds-1)
            }, 1000)
            return () => {
                clearTimeout(timeout)
            }
        } else {
            setCountdownComplete(true)
        }
    },[remainingSeconds])

    useEffect(()=>{
        if(countdownComplete) {
            setRedirect(true)
        }
    }, [countdownComplete])

    if(redirect) {
        return (<Redirect to={`${APP_DIRECTORY}/login`}/>)
    } else {
        return (<div className="redirectCountdown">
            <Alert variant={'success'}>
                <Alert.Heading>Successfully verified!</Alert.Heading>
                <hr />
                You will automatically be redirected to log in after {remainingSeconds} seconds.
            </Alert>
        </div>)
    }
}

export default RedirectCountdownToLogin
